import ReactDOM from "react-dom/client";
import { IntlProvider } from "react-intl";
import React from "react";
import { router } from "./router";

import "./index.css";
import "./theme.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import { onLCP, onFID, onCLS } from "web-vitals";

onCLS(console.log);
onFID(console.log);
onLCP(console.log);

function loadLocaleData(locale: string | undefined) {
  switch (locale?.toLowerCase()) {
    case "fr":
      return import("../public/compiled-lang/fr.json");
    case "fr-fr":
      return import("../public/compiled-lang/fr.json");
    default:
      return import("../public/compiled-lang/en.json");
  }
}

const detectBrowserLocale = (): readonly string[] => {
  return navigator.languages === undefined
    ? [navigator.language]
    : navigator.languages;
};
const defaultLocale = "en";
const locale = detectBrowserLocale().find((x) => x != undefined);

const container = document.getElementById("root");
if (container) {
  loadLocaleData(locale).then((allMessages) => {
    const messages = allMessages.default;
    const root = ReactDOM.createRoot(container);
    root.render(
      <React.StrictMode>
        <IntlProvider
          locale={locale ? locale : defaultLocale}
          defaultLocale={defaultLocale}
          messages={messages}
        >
          <RouterProvider router={createBrowserRouter(router())} />
        </IntlProvider>
      </React.StrictMode>
    );
  });
}
